import classNames from 'classnames'
import { createElement, forwardRef } from 'react'

import { typographyAs, typographyColor, typographyType } from './constants'
import styles from './typography.module.css'
import { ITypographyProps } from './typography.type'

const Typography = forwardRef<HTMLElement, ITypographyProps>(function Typography({
    children,
    type = typographyType.body1,
    color = typographyColor.accent,
    as = typographyAs.div,
    className,
    ...rest
}, ref) {
    const typographyClassNames = classNames(
        styles.typography,
        color,
        type,
        {
            [styles.inlineBlock]: as === "span" || as === "a",
        },
        className,
    )

    return (
        createElement(
            as,
            { className: typographyClassNames, ref: ref, ...rest },
            children
        )
    )
})

export default Typography
